import { useCallback, useState } from 'react';

export function useContextMenuState() {
    const [position, setPosition] = useState(null);
    const [params, setParams] = useState(null);

    const close = useCallback(() => {
        setPosition(null);
    }, []);

    const open = useCallback((event, params) => {
        event.preventDefault();
        setPosition({ x: event.clientX, y: event.clientY });
        setParams(params);
    }, []);

    const onOpenChange = useCallback((isOpen) => !isOpen && close(), [close]);

    return {
        isOpen: Boolean(position),
        x: position?.x ?? 0,
        y: position?.y ?? 0,
        params,
        open,
        close,
        onOpenChange
    };
}
